import React, { useEffect, useState } from 'react';
import useContentfulCalculators from '../contentfulCalculators';
import Container from './Container';

const RetirementCalculatorComponent = () => {
    const calculators = useContentfulCalculators();
    const [filteredCalculator, setFilteredCalculator] = useState(null);
    const [showResults, setShowResults] = useState(false);
    const [dbTotal, setDBTotal] = useState(0);

    useEffect(() => {
        const retirementCalculator = calculators.find(calculator => calculator.fields.title === 'Retirement Calculator');
        if (retirementCalculator) {
            setFilteredCalculator(retirementCalculator);
        }
    }, [calculators]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const dbAgeVal = parseInt(formData.get('dbAge'));
        const dbSchemeAgeVal = parseInt(formData.get('dbSchemeAge'));
        const dbRetirementAgeVal = parseInt(formData.get('dbRetirementAge'));
        const dbIncomeVal = parseFloat(formData.get('dbIncome').replace(/,/g, ''));
        const dbAccRateVal = parseInt(formData.get('dbAccRate'));
        const dbTillRet = dbRetirementAgeVal - dbAgeVal;
        const dbSchemeYears = dbTillRet + dbSchemeAgeVal;
        const dbTotal = (dbIncomeVal * dbSchemeYears) * (1 / dbAccRateVal);
        setDBTotal(Math.ceil(dbTotal));
        setShowResults(true);
    };
    

    if (!filteredCalculator) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <div id={`calculator-${filteredCalculator.sys.id}`}>
                {/* Ensure that each form input has a unique name attribute */}
                <form onSubmit={handleSubmit} dangerouslySetInnerHTML={{ __html: filteredCalculator.fields.htmlCode }} />
            </div>

            {showResults && (
                <div id="pensionResult" className="w-full max-w-lg mx-auto grid place-items-center pb-16">
                    <h2 className="text-xl font-bold text-center">Results</h2>
                    <p className="text-center">This is an estimate of the yearly income from your DB pension scheme.</p>
                    <div className="mt-5 text-center">
                        {/* Display the calculated DB total */}
                        <p><span className='font-semibold'>£{dbTotal.toLocaleString()}</span> a year DB pension income</p>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default RetirementCalculatorComponent;
